import axios from 'axios'

import {
  ApiType,
  getAxiosConfiguration,
  requestHandler,
  responseHandler,
  errorHandler
} from './configuration'

const axiosConfiguration = getAxiosConfiguration(ApiType.LoginSSO)
const loginSsoApiClient = axios.create(axiosConfiguration)

loginSsoApiClient.interceptors.request.use(requestHandler, errorHandler)
loginSsoApiClient.interceptors.response.use(responseHandler, errorHandler)

export { loginSsoApiClient }
